import Logger from 'js-logger';
import moment from 'moment';
import Vue from 'vue';

const consoleLogger = Logger.createDefaultHandler({
  formatter: () => {} // remove default context.name injection
});

Logger.setHandler((messages, context) => {
  messages = Object.values(messages);
  const inject = [
    moment().format('YYYY-MM-DD HH:mm:ss'),
    `[${context.level.name}]`
  ];
  if (context.name) {
    inject.push(`[${context.name}]`);
  }
  messages.unshift(...inject);
  consoleLogger(messages, context);
});

Logger.setLevel(Logger.DEBUG);

const LoggingMixin = {
  beforeCreate() {
    // inject a logger into each component using it's name
    if (!this.constructor.hasOwnProperty('extendOptions') || !this.constructor.extendOptions.hasOwnProperty('name')) {
      this.$logger = Logger;
    } else {
      this.$logger = Logger.get(this.constructor.extendOptions.name);
    }
  }
};

Vue.mixin(LoggingMixin);

export {
  Logger
}

